<template>
  <b-navbar
    style="background-color: #000000 !important;"
    toggleable="lg"
    type="dark"
    variant="dark"
  >
    <b-container>
      <b-navbar-brand to="/Home">
        <b>
          CRM System
        </b>
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse" />

      <b-collapse
        id="nav-collapse"
        is-nav
      >
        <b-navbar-nav>
          <b-nav-item to="/Customers">
            Customers Data
          </b-nav-item>
          <b-nav-item to="/Mailer">
            Mailing System
          </b-nav-item>
          <b-nav-item to="/Survey">
            Surveys Management
          </b-nav-item>
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item-dropdown right>
            <!-- Using 'button-content' slot -->
            <template #button-content>
              <em><i class="fa fa-user-circle-o orange">&ensp;{{ username }}</i></em>
            </template>
            <b-dropdown-item
              variant="dark"
              class="tag"
              @click="logout"
            >
              Sign Out
            </b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-container>
  </b-navbar>
</template>

<script>
export default {
  name: 'Header',
  data () {
    return {
    }
  },
  computed: {
    username () {
      const user = this.$store.state.Auth
      if (!user.user) {
        return ''
      }
      return user.username
    }
  },
  methods: {
    logout () {
      return this.$store.dispatch('Auth/logout')
        .then(() => {
          this.$router.push({ name: 'Login' })
        })
        .catch(err => this.throwReject(err))
    }
  }
}
</script>

<style scoped>
.tag {
  cursor: pointer;
}
.white {
  color: white;
}
.orange {
  color: orange;
}
</style>
